// extracted by mini-css-extract-plugin
export var headerXL = "SectionFeatures-module--headerXL--2FH5n";
export var headerL = "SectionFeatures-module--headerL--3oaGo";
export var headerM = "SectionFeatures-module--headerM--1l-o8";
export var headerS = "SectionFeatures-module--headerS--2H7sE";
export var headerXS = "SectionFeatures-module--headerXS--1Um1H";
export var blogHeaderXL = "SectionFeatures-module--blogHeaderXL--5L1OQ";
export var blogHeaderL = "SectionFeatures-module--blogHeaderL--3hCsd";
export var blogHeaderM = "SectionFeatures-module--blogHeaderM--2qdDA";
export var blogHeaderS = "SectionFeatures-module--blogHeaderS--2lnof";
export var blogHeaderXS = "SectionFeatures-module--blogHeaderXS--3wG8_";
export var headerPreamble = "SectionFeatures-module--headerPreamble--2-gEg";
export var preHeader = "SectionFeatures-module--preHeader--1obL-";
export var textNormal = "SectionFeatures-module--textNormal--2hKXc";
export var textSmall = "SectionFeatures-module--textSmall--3fwq2";
export var textSmallAlternate = "SectionFeatures-module--textSmallAlternate--1VE6T";
export var legend = "SectionFeatures-module--legend--1cOp7";
export var caption = "SectionFeatures-module--caption--3SMlQ";
export var gradientBackground = "SectionFeatures-module--gradientBackground--2WqlO";
export var ellipsis = "SectionFeatures-module--ellipsis--1EuXA";
export var globalContainer = "SectionFeatures-module--globalContainer--1Ub3N";
export var maxWidth = "SectionFeatures-module--maxWidth--147HV";
export var clipBottom = "SectionFeatures-module--clipBottom--GS1iT";
export var clipTopBottom = "SectionFeatures-module--clipTopBottom--1TT39";
export var featureSection = "SectionFeatures-module--featureSection--3yyZB";
export var card = "SectionFeatures-module--card--5BwKC";
export var firstCard = "SectionFeatures-module--firstCard--2kPUF";
export var middleCard = "SectionFeatures-module--middleCard--1ULth";
export var endCard = "SectionFeatures-module--endCard--27dTm";
export var ch2 = "SectionFeatures-module--ch2--2oMkK";
export var ch2Container = "SectionFeatures-module--ch2-container--3vtwd";